<template>
  <div class="favourite-card">
    <component :is="linkComponent" v-bind="linkAttrs">
      <div class="favourite-card__top">
        <div class="favourite-card__diamond">
          <div :class="classDiamond"/>
        </div>
        <div :class="['favourite-card__column-main', {'favourite-card__column-main--full-width': !$slots['side']}]">
          <div class="favourite-card__title">
            <slot name="title"/>
          </div>
          <div class="favourite-card__subtitle">
            <slot name="sub-title"/>
          </div>
        </div>
        <div
          v-if="$slots['side']"
          class="favourite-card__column-side"
        >
          <slot name="side"/>
        </div>
      </div>

      <div
        v-if="$slots['bottom']"
        class="favourite-card__bottom"
      >
        <slot name="bottom"/>
      </div>
    </component>

    <button
      v-if="removable"
      class="favourite-card__remove print-hide"
      @click="$emit('remove')"
      data-cy="remove-from-cart"
    >
      <TrashIcon />
    </button>
  </div>
</template>

<script>
  import TrashIcon from '../icons/TrashIcon.vue';

  export default {
    props: {
        url: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: null,
        },
        colorDiamond: {
            type: String,
            default: null,
        },
        removable: {
            type: Boolean,
            default: true,
        },
        target: {
            type: String,
            default: "_self",
        },
    },
    computed: {
        // Vue 3: separate the component type from attributes
        linkComponent() {
            return this.url ? 'a' : 'div';
        },
        linkAttrs() {
            return this.url ? {
                href: this.url,
                target: this.target,
            } : {};
        },
        // Keep vBindLink for backwards compatibility if used elsewhere
        vBindLink() {
            return this.url ? {
                is: "a",
                href: this.url,
                target: this.target,
            } : {
                is: "div",
            };
        },
        classDiamond() {
            const color = this.colorDiamond ? this.colorDiamond : this.color;
            return [
                "diamond",
                "diamond--flat",
                { [`diamond--${color}`]: color && color !== "default" },
            ];
        },
    },
    components: { TrashIcon }
}
</script>

<style lang="scss">
  @import "~styles/definitions";

  .favourite-card {
    position: relative;
    background-color: $color-green-lighter-2025;
  }

  .favourite-card__top {
    display: flex;
    padding: r(16) r(20) r(16);
  }

  .favourite-card__diamond {
    @include square(r(16));
    flex-shrink: 0;
    margin-top: r(4);
  }

  .favourite-card__column-main {
    flex: 1;
    margin-left: r(14);
    margin-right: r(8);

    &--full-width {
      margin-right: r(28);
    }
  }

  .favourite-card__column-side {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: r(96);
  }

  .favourite-card__title {
    @include font-heavy-16();
    display: block;
  }

  .favourite-card__subtitle {
    @include font-body-12();
    display: block;
  }

  .favourite-card__bottom {
    margin-left: r(54);
    margin-right: r(48);
    padding: r(12) 0 r(20);
    border-top: r(1) solid rgba($color-blue-dirty, 0.15);
  }

  .favourite-card__remove {
    @include reset-button();
    position: absolute;
    top: r(16);
    right: r(16);
    color: $black;
    margin-bottom: auto;
  }
</style>
